import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { HomeManagementModule } from '@/modules/fantasy/home-management';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  sport: z
    .string()
    .optional()
    .transform((value): 'cricket' | 'football' | 'kabaddi' => {
      if (value === 'football' || value === 'kabaddi' || value === 'cricket') {
        return value;
      }
      return 'cricket';
    }),
  tourId: z
    .string()
    .optional()
    .transform(value => value ?? ''),
});

export const Route = createFileRoute('/dashboard/fantasy/home-management/')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { canAccessHomeManagement } = useAccessControl();
  if (!canAccessHomeManagement) {
    return <AccessDenied />;
  }
  return <HomeManagementModule />;
}
